
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ru",
  "uk",
  "pl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_getTranslations_46js_eb76b202",
      load: () => import("#nuxt-i18n/eb76b202" /* webpackChunkName: "locale_getTranslations_46js_eb76b202" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_getTranslations_46js_eb76b202",
      load: () => import("#nuxt-i18n/eb76b202" /* webpackChunkName: "locale_getTranslations_46js_eb76b202" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_getTranslations_46js_eb76b202",
      load: () => import("#nuxt-i18n/eb76b202" /* webpackChunkName: "locale_getTranslations_46js_eb76b202" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_getTranslations_46js_eb76b202",
      load: () => import("#nuxt-i18n/eb76b202" /* webpackChunkName: "locale_getTranslations_46js_eb76b202" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "en",
      language: "en",
      files: [
        {
          path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "ru",
      language: "ru-ru",
      files: [
        {
          path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      name: "uk",
      language: "uk-ua",
      files: [
        {
          path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      name: "pl",
      language: "pl-pl",
      files: [
        {
          path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://joinu.app",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "en",
    language: "en",
    files: [
      {
        path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "ru",
    language: "ru-ru",
    files: [
      {
        path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    name: "uk",
    language: "uk-ua",
    files: [
      {
        path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "pl",
    language: "pl-pl",
    files: [
      {
        path: "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@4/i18n/locales/getTranslations.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/